
import { RouteRecordRaw } from "vue-router";

export const authRoutes: Array<RouteRecordRaw> = [
    {
        path: '/auth',
        name: 'auth-layout',
        component: () => import('@/layouts/AuthLayout.vue'),
        children: [
            {
                path: '',
                name: 'default-auth',
                redirect: 'auth/login',
            },
            {
                path: 'login',
                name: 'login',
                component: () => import('@/pages/auth/LoginPage.vue'),
            },
            {
                path: 'login-admin',
                name: 'login-admin',
                component: () => import('@/pages/admin/AdminLoginPage.vue'),
            }
        ],
    }
]